module.exports = new __parcel__URL__("PartialOutageError.fd67bc0a.svg").toString();